$(window).on('popstate', function() {
       window.setTimeout('location.reload()', 3000);
   });
$( document ).ready(function() {

  $("ul.left-menu .cstm-menu-li:nth-child(2)").toggleClass("menulast");
   // $("ul.cstm-menu .cstm-menu-li:nth-child(5)").addClass("menulast lastone");
                 
$('.product-carousel').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 2,
  autoplay:true,
  arrows:false,
  responsive: [
    {
      breakpoint: 1281,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll:3
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   
  ]
});
$('.cstm-slider-area').slick({
  infinite: true,
  slidesToShow: 7,
  slidesToScroll: 2,
  autoplay:true,
  arrows:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   
  ]
});
  // ----------------- popup video section --------------     
  $('.product-grids-items .main-product-card.video_popup_wrapper' ).on( "click", function() {
            var id_attr = $(this).attr('data-id');
        var images1 = $('#img-'+id_attr).html();
        $('#show_img2').html(images1);
     $("body").addClass('active');
      $(".custom-model-main").addClass('model-open');
    $("#show_img2 .custom_inner_wrapper .popup_video_inner video").trigger("play");
    });
    $(".close-btn.data.close-btn").click(function(){
    $(".custom-model-main").removeClass('model-open');
      $("body").removeClass('active');
      $("#show_img2 .custom_inner_wrapper .popup_video_inner video").trigger("pause");
      $(".custom_inner_wrapper .popup_video_inner video").get(0).currentTime = 0;
  });

// ------------end-------------
  
$('.donate-grid').slick({
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 2,
  autoplay:false,
  arrows:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      }
    }
   
  ]
});
$('.about-slide-img').slick({
  infinite: false,
  slidesToScroll: 1,
  autoplay:false,
  arrows:true,
  vertical: true,
  dots: true,
verticalSwiping: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
       
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   
  ]
});
$(".grid__item.tab-title .tab").click(function(){
    $('.tab-products').slick('unslick');
  $('.tab-products').slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  
  ]
});
  });
$('.image-slides-wrapper').slick({
  infinite: true,
  slidesToScroll: 1,
  autoplay:true,
  arrows:false,
  vertical: true,
  verticalSwiping: true
});

// product tooltip
if($('.product-accordion').length > 0){
    $('span.link-label').click(function() {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
    } else {
$('span.link-label').removeClass('active');
        $(this).addClass('active');
    }
});
   $('body').click(function(event){
    if(!$(event.target).closest('span').length) {
      $('span.link-label').removeClass('active');
    }
  });
}
  
// product view ingredients
  if ($(window).width() > 767) {
 $("a.read-more-collection").click(function() {
        $('.product-accordion-wrapper-1 .acc-pls-icon.desktop_icon').parents('.outer-wrapper').addClass('current');
       $('.product-accordion-wrapper-1 .acc-pls-icon.desktop_icon').parents('.outer-wrapper').find('.hide-data.product-accordion-content').css("display", "block");
        $('html, body').animate({
            scrollTop: $('#ingredients').offset().top-100
        }, 1500);
    });
  }
if ($(window).width() < 767) {
 $("a.read-more-collection").click(function() {
        $('.product-accordion-wrapper-1 .acc-pls-icon.desktop_icon').parents('.outer-wrapper').addClass('current');
       $('.product-accordion-wrapper-1 .acc-pls-icon.desktop_icon').parents('.outer-wrapper').find('.hide-data.product-accordion-content').css("display", "block");
        $('html, body').animate({
            scrollTop: $('#ingredients').offset().top-50
        }, 1000);
    });
};
//help-center FAQ Page
  
if($('.custom-sec-faq').length > 0){
     $(".accordion").on("click", ".top_content", function() {
       // $('.accordion:first').show();
   
       if($(this).hasClass('active')){
         $(this).removeClass("active").next().slideUp();
       }else{
         $('.top_content.active').removeClass("active");
         $(".bottom_content").not($(this).next()).slideUp(300);
         $(this).addClass("active").next().slideDown();
       }
     });
     $(".faq-left-content .tab_list>.tabs").on("click",function(e) {
       e.preventDefault();
       $(".faq-left-content .tab_list>.tabs").removeClass("current");
       $(this).addClass("current");
       // $(".accordion-item").hide();
       var tab_id = $(this).attr('id');
       $("#data-" +tab_id).show();
       $('.accordion-item').removeClass('current');
       $("#data-" +tab_id).addClass('current');
        $('html,body').animate({
            scrollTop: $("#data-" +tab_id).offset().top - $('header').outerHeight() - 50
        }, 1000);
     }); 
   }
   
  
// quantity button

$('.plus').on('click', function() {
            var $quantityInput = $(this).siblings('.product-quantity');
            var currentValue = parseInt($quantityInput.val());
            $quantityInput.val(currentValue + 1);
  var total_qty = parseInt($quantityInput.val());
          $('.minus').removeAttr('disabled');
  console.log(total_qty);
  $(this).siblings('.qty_count').text(total_qty);
        });

$('.minus').on('click', function() {
    var $quantityInput = $(this).siblings('.product-quantity');
    var currentValue = parseInt($quantityInput.val());
    if (currentValue > 1) {
        $quantityInput.val(currentValue - 1);
        $(this).removeAttr('disabled');
      var total_qty = parseInt($quantityInput.val());
      console.log(total_qty)
      $(this).siblings('.qty_count').text(total_qty);
    }
  if (currentValue == 1) {
    $(this).attr('disabled', true);
  }
});

// collections Url
 
const pathName = window.location.pathname;
    const parts = pathName.split('/');
    const lastName = parts[parts.length - 1];
 
    
if ($('body').hasClass('collection') ) {
    $('.tab-pane').removeClass('active');
      }
   $('.tab-pane[data-collection="'+lastName+'"]').addClass('active');

  if ($('body').hasClass('collection') ) {
        $('.tab').removeClass('active');
    }
   $('.tab[data-collection="'+lastName+'"]').addClass('active');
  $('.tab[data-collection="'+lastName+'"].active').trigger('click');
 

if($('.custom-main-product').length > 0){
$('.tips-area').click(function () {  
  $('.mini-popup').toggleClass('active');
});
   $('body').click(function(event){
    if(!$(event.target).closest('.tips-area').length) {
      $('.mini-popup').removeClass('active');
    }
  });
}
  
 $('.acc-pls-icon').click(function () {
    $(this).parents('.outer-wrapper').toggleClass('current');
   $(this).parents('.outer-wrapper').find('.hide-data').slideToggle();
 });
$('.more-info-btn').click(function() {
   $(this).parents('.outer-wrapper').addClass('active')
  $(this).parents('.outer-wrapper').find('.hide-data').slideDown();
});
  $('.less-info-btn').click(function() {
     $(this).parents('.outer-wrapper').removeClass('active');
    $(this).parents('.outer-wrapper').find('.hide-data').slideUp();
  });

// faq page
$('.custom-faq .tab-content').hide();
$('.tab-wrapper').find('.tab-content').first().show();
$('.custom-faq .tab-title').click(function () {
    $(this).parents('.tab-wrapper').find('.tab-content').slideToggle();
 }); 

$('.ankortag').find('.product-accordion-desc a').each(function(index){ 
    var oldUrl = $(this).attr("href");
   $(this).addClass('data-active-' + index);
});
  
  $('.accordion__content').hide();
  $('.accordion__title').click(function () {
    $(this).parents('.accordion').find('.accordion__content').slideToggle();
    $(this).parents('.accordion').toggleClass('active');
});

// blog page load more button 
var articlesPerPage = 9;
let currentSelectedBlog = $('body.blog .tab.active').data('collection');
// var articles = $('.blog-articles').hide(); // Hide all articles initially
 
// Show articles belonging to the currentSelectedBlog and hide excess ones
articles.each(function() {
    var ids = $(this).attr('id').split('-');
    if (ids.length > 1 && ids[1] == currentSelectedBlog) {
        $(this).show();
        var articleli = $(this).find('ul li.article');
        articleli.slice(articlesPerPage).hide();
    }
});
 
// Click handler for the show more button
$('#load-more-btn').on('click', function() {
    var hiddenArticles = $('.blog-articles:visible ul li.article:hidden');
    var nextArticles = hiddenArticles.slice(0, articlesPerPage);
    if (nextArticles.length > 0) {
nextArticles.show();
    } else {
        $(this).hide(); // Hide the show more button when there are no more articles to show
    }
});

  // product page quantity
  
$('.quantity__input').on('change', function() {
        // Call the update function
        updateTotalPrice();
    });

function updateTotalPrice() {
        // Get the price and quantity values
        var price = parseFloat($('.inc-quantity').text().replace('$', '').trim());
        var quantity = parseInt($('.quantity__input').val());

        // Calculate the total price
        var totalPrice = price * quantity;

        // Update the text inside inc-quantity div
        $('.inc-quantity').text('$' + totalPrice.toFixed(2)); // Assuming two decimal places for currency
    }
  
// sorting blog page
  $('#sort-by').change(function() {
        var sortBy = $(this).val();
        var $activeTabPane = $('.tab-pane.active');
        
        if (sortBy === 'featured') {
            // Do nothing, as it's already sorted by default
        } else if (sortBy === 'old-new') {
            // Sort by data-date, old to new
            $activeTabPane.find('ul li').sort(function(a, b) {
                var dateA = $(a).data('date');
                var dateB = $(b).data('date');
                return new Date(dateA) - new Date(dateB);
            }).appendTo($activeTabPane.find('ul'));
        } else if (sortBy === 'new-old') {
            // Sort by data-date, new to old
            $activeTabPane.find('ul li').sort(function(a, b) {
                var dateA = $(a).data('date');
                var dateB = $(b).data('date');
                return new Date(dateB) - new Date(dateA);
            }).appendTo($activeTabPane.find('ul'));
        } else if (sortBy === 'a-z') {
            // Sort by data-title, A-Z
            $activeTabPane.find('ul li').sort(function(a, b) {
                var titleA = $(a).data('title').toUpperCase();
                var titleB = $(b).data('title').toUpperCase();
                return (titleA < titleB) ? -1 : (titleA > titleB) ? 1 : 0;
            }).appendTo($activeTabPane.find('ul'));
        } else if (sortBy === 'z-a') {
            // Sort by data-title, Z-A
            $activeTabPane.find('ul li').sort(function(a, b) {
                var titleA = $(a).data('title').toUpperCase();
                var titleB = $(b).data('title').toUpperCase();
                return (titleB < titleA) ? -1 : (titleB > titleA) ? 1 : 0;
            }).appendTo($activeTabPane.find('ul'));
        }
    });

   // document ready bracket
});

// collections filters code start from here

if($('.cstm-coll').length > 0){
  // new code for collection filters
  $('.tab').click(function(e) {
    e.preventDefault();
    var sun = $(this).parents('.collection__wrapp').find('.tab-content');
    console.log(sun, 'sun');
    $('.tab').removeClass('active');
    $(this).addClass('active');
    var get_url = $(this).attr('data-link');
    var coll_link = get_url.split('?');

    var tab_url = $(this).attr('data-collection');
    var id = $(this).attr('data-index');
    var coll_url = $('.tab-pane-'+id).attr('data-collection');

    $('.tab-pane').removeClass('active');
    if (tab_url == coll_url) {
        $('.tab-pane-'+id).addClass('active');
    }

    // Push state to update URL
    // window.history.pushState('', '', coll_link[0] );
    
    // Ajax request to fetch data
    $.ajax({
        url: coll_link[0],
        type: 'GET',
        success: function(data) {
          var result_sort = $(data).find(".tab-pane-"+id).parent('.tab-content').find('.filter-wrappr').html();
           $('.filter-wrappr').html(result_sort);
            var result_data = $(data).find(".tab-pane-"+id).html(); 
            $(".tab-pane-"+id).html(result_data).addClass('active').show();
          
           
          
          // collections filters
          $('#tabFilters').change(function() {
             var select = $(this).val();
          $('.tab-pane.active .prd-area').hide();
          $('.tab-pane.active .prd-area').each(function() {
                 var dataTags = $(this).data('tag');
            console.log(dataTags, 'ss');
                 // Check if dataTags is defined and not null
                 if (typeof dataTags !== 'undefined' && dataTags !== null) {
                     if (dataTags.includes(',')) {
                         dataTags = dataTags.split(',');
                     } else {
                         dataTags = [dataTags];
                     }
                     if (dataTags.includes(select)) {
                         $(this).show();
                     }
                 }
             });
          });
            // collection page 
          $("select#tabFilters").change(function(){
            var value = $('select#tabFilters option:selected').val();
            if(value == 'all'){
              $(".collections-tab .tab-pane.active .prd-area").css("display", "flex");    
            }
          });
        
        $(window).on("load", function() {
             console.log("click disable")
          $( ".collections-tab .tab.active" ).trigger("click");
          $( ".collections-tab .tab.active" ).trigger("click");
           });
  
        }
    });
});
        $('#tabFilters').change(function() {
             var select = $(this).val();
          $('.tab-pane.active .prd-area').hide();
          $('.tab-pane.active .prd-area').each(function() {
                 var dataTags = $(this).data('tag');
            console.log(dataTags, 'ss');
                 // Check if dataTags is defined and not null
                 if (typeof dataTags !== 'undefined' && dataTags !== null) {
                     if (dataTags.includes(',')) {
                         dataTags = dataTags.split(',');
                     } else {
                         dataTags = [dataTags];
                     }
                     if (dataTags.includes(select)) {
                         $(this).show();
                     }
                 }
             });
          });
            // collection page 
          $("select#tabFilters").change(function(){
            var value = $('select#tabFilters option:selected').val();
            if(value == 'all'){
              $(".collections-tab .tab-pane.active .prd-area").css("display", "flex");    
            }
          });
        
        $(window).on("load", function() {
             console.log("click disable")
          $( ".collections-tab .tab.active" ).trigger("click");
          $( ".collections-tab .tab.active" ).trigger("click");
           });
  }
else
{
    // JavaScript for Collections Tab
    document.addEventListener("DOMContentLoaded", function() {
    
    const parentsDiv = document.querySelectorAll('.collections-tab');
      
      const tabs = document.querySelectorAll('.tab');
      const tabPanes = document.querySelectorAll('.tab-pane');
    
      tabs.forEach(tab => {
        tab.addEventListener('click', function() {
        
          const targetCollection = this.getAttribute('data-collection');
          tabs.forEach(tab => tab.classList.remove('active'));
          tabPanes.forEach(pane => pane.classList.remove('active'));
          this.classList.add('active');
           document.querySelector(`.tab-pane[data-collection="${targetCollection}"]`).classList.add('active');
        });
      });
    
    });
}

// code for Blog tags
if(document.querySelector('.article-wrap') != null){
  document.addEventListener("DOMContentLoaded", function() {
  
    const tabs = document.querySelectorAll('.blog-tg');
    const tabPanes = document.querySelectorAll('.article-img');
    const articleWraps = document.querySelectorAll('.article-wrap'); 
  
   
    const firstArticleWrap = document.querySelector('.article-wrap');
    firstArticleWrap.classList.add('active');
  
     const secondTab = tabs[1];
    secondTab.classList.add('active');
    
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const targetCollection = this.getAttribute('data-tag');
        tabs.forEach(tab => tab.classList.remove('active'));
        tabPanes.forEach(pane => pane.classList.remove('active'));
        this.classList.add('active');
        articleWraps.forEach(wrap => wrap.classList.remove('active')); 
        document.querySelector(`.article-wrap[data-tag="${targetCollection}"]`).classList.add('active');
      });
    });
  });
}

// $(document).on('click', 'body.collection .tab[data-collection], body.blog .tab[data-collection]', function(event) {
//     var newUrl = $(this).data('collection');
//     window.history.pushState({}, '', newUrl);
// });

// blog filters

document.addEventListener('DOMContentLoaded', function() {
    var tabs = document.querySelectorAll('body.blog .tab');
  
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var collectionHandle = this.getAttribute('data-collection');
        var articles = document.querySelectorAll('.article');
        articles.forEach(function(article) {
          article.style.display = 'none';
        });
        var currentArticles = document.querySelectorAll('#blog-' + collectionHandle + ' .article');
        currentArticles.forEach(function(article) {
          article.style.display = 'block';
          $('.blog-articles:not(.blog-articles.active)').hide();
          $('.blog-articles.active').find('ul li.article').slice(9).hide();
        });

        // Optional: Add active class to current tab
        tabs.forEach(function(tab) {
          tab.classList.remove('active');
        });
        this.classList.add('active');
      });
    });
  });

$('.about-inner_img').find('h3').first().addClass('active');
$('.about-banner-inner').on('afterChange', function(event, slick, currentSlide) {
    // Remove active class from all h3 elements
    $('.about-inner_img').find('h3').removeClass('active');
    
    // Add active class to the h3 element in the current slide
    $('.slick-slide').eq(currentSlide).find('h3').eq(currentSlide).addClass('active');
});

// where to Buy Popup
$('li.Where_to_Buy, li.menu_header.Where-to-Buy').click(function(e) {
  e.preventDefault();
  $('#buymyModal').show();
  $('#buymyModal').addClass('active');
});
//li.Community_Involvement
$('.footer-block__details-content li.Community_Involvement').click(function(e) {
  e.preventDefault();
 window.location.href= "https://www.zaxsoriginal.com/pages/our-mission#shopify-section-template--16880112566457__giving_back_6txLAP"
});
 $(document).on("click", "button.close", function() {
    
      $('#buymyModal').hide();
    });

// shiping Policy popup
$('li a.helpful-links-2').click(function(e) {
  e.preventDefault();
  $('#shipingReturns').show();
  $('#shipingReturns').addClass('active');
});
 $(document).on("click", "button.close", function() {
      $('#shipingReturns').hide();
    });

// moneyBackguarantee Popup
$('li.Money_Back_Guarantee').click(function(e) {
  e.preventDefault();
  $('#moneyBackguarantee').show();
  $('#moneyBackguarantee').addClass('active');
});
 $(document).on("click", "button.close", function() {
      $('#moneyBackguarantee').hide();
    });
// return popup
$('ul.footer-block__details-content.list-unstyled a.link.link--text.list-menu__item.list-menu__item--link.helpful-links-3').click(function(e) {
  e.preventDefault();
  console.log("fsfsf");
    $('.modal.fade-return').addClass('model-open');
   $('body').addClass('return-open');
});
 $(document).on("click", ".modal.fade-return.model-open button.close", function(e) {
     e.preventDefault();
       $('.modal.fade-return').removeClass('model-open');
   $('body').removeClass('return-open');
    });

$(document).ready(function() {


  // ------------sticy product js-------------

  // $(".custom_cart_section .product-form_cart").click(function(){
  //         $("form").each(function() {
  //     $(this).on("submit", function(e) {
  //         if(!$(this).hasClass("submitted")) {
  //             e.preventDefault();
  //             var form = $(this);
  //             setTimeout(function() {
  //                 form.submit();
  //             }, 1000);
  //             var data = $(this).serialize();
  //             $(this).addClass("submitted");
  //         }
  //     });
  // });
  //   var set_quantity = $('.stick_quantity_wrapper input#Quantity').val();
  //   var product_id = $('.no-js-hidden.pdp_price_wrapper').attr("product_variant_id")
  //       console.log(set_quantity);
  //       var product_items = {
  //         'id': product_id,
  //         'quantity':set_quantity
  //       };
  //       // console.log(product_items)
  //       {
  //            $.ajax({
  //                  type: "POST",
  //                  url: '/cart/add',
  //                  data: { items: [product_items] },
  //                  success: function(data) {
  //                    console.info('success',data);
  //                  },
  //              });
  //       }
  // });

   $(".sticky-bottom-price .quantity__button[name='plus']").click(function(){
     console.log("sdfsf");
       $( ".custom_dark_wrapper button.quantity__button.no-js-hidden[name='plus']" ).trigger( "click" );    
});
   $(".sticky-bottom-price .quantity__button[name='minus']").click(function(){
     console.log("sdfsf");
       $( ".custom_dark_wrapper button.quantity__button.no-js-hidden[name='minus']" ).trigger( "click" );    
});

   $(".quantity__button.no-js-hidden").click(function () {
var text = $('.no-js-hidden.pdp_price_wrapper').attr("pdp_price")
     var data_input = $('.stick_quantity_wrapper input#Quantity').val();
  console.log(text);
console.log(data_input);
       var total_price_update=((data_input*text).toFixed(2));
console.log(total_price_update);
$('.productPriceContainer').text('$'+total_price_update);
 });

  $(".custom_cart_section .product-form_cart").click(function(){
     console.log("sdfsf");
       $( ".product-form__submit.button.button--full-width.button--secondary" ).trigger( "click" );    
});
 $("button#cart_btn").click(function () {
   setTimeout (function () {
    var text = $('.stick_quantity_wrapper .quantity-data').attr("value");
     $('.stick_quantity_wrapper .quantity-data').val(text);
  console.log(text);
var text = $('.no-js-hidden.pdp_price_wrapper').attr("pdp_price")
     var data_input = $('.stick_quantity_wrapper input#Quantity').val();
  console.log(text);
console.log(data_input);
       var total_price_update=((data_input*text).toFixed(2));
console.log(total_price_update);
$('.productPriceContainer').text('$'+total_price_update);
   },1000);
 });

});

$(document).ready(function(){
$("#leave-reviews").click(function() {
  $('html, body').animate({
      scrollTop: $("#leave-review").offset().top
  }, 2000);
});
});

// $('.installment.caption-large .add-to-cart-btn').click(function() {
//           $("form").each(function() {
//       $(this).on("submit", function(e) {
//           if(!$(this).hasClass("submitted")) {
//               e.preventDefault();
//               var form = $(this);
//               setTimeout(function() {
//                   form.submit();
//               }, 1000);
//               var data = $(this).serialize();
//               $(this).addClass("submitted");
//           }
//       });
//   });
 
// var pdp_id = $(this).attr("product_id");
//     var pdp_class = $(this).attr("main_handle");
//     console.log(pdp_id );
//     console.log(pdp_class);
// var product_id = $('.installment.caption-large .qty_count.'+pdp_class).text();
// console.log(product_id);
//         let product_items = {
//           'id':pdp_id,
//           'quantity':product_id
//         };
//         console.log(product_items)
//         {
//              $.ajax({
//                    type: "POST",
//                    url: '/cart/add',
//                   cache:false,
//                    data: product_items,
               
//                    success: function(data) {
//                       $('cart-drawer').removeClass("is-empty");
//                        $('#CartDrawer .drawer__inner-empty').hide();
//                        $('cart-drawer').load(location.href + "#CartDrawer");
//                      console.info('success');
//                    },
//                  error:function (xhr, ajaxOption, thrownError) {
//                       console.info('failed');
//                  }
//                });
//         }
//   });
// $(document).ready(function(){
//     // When the clear cart link is clicked
//     $('.clear_cart').click(function(e){
//         e.preventDefault(); // Prevent the default behavior of the link
        
//         // Send an AJAX request to clear the cart content
//         $.ajax({
//             url: '/cart/clear',
//             type: 'POST', // You can change this to 'GET' if that's what your server expects
//             success: function(response){
//                 // If the cart is cleared successfully, do nothing or show a message
//                 console.log('Cart cleared successfully.');
//                 // Optionally, you can display a message indicating that the cart is cleared
//                 // $('#cart_cleared_message').fadeIn().delay(2000).fadeOut();
//             },
//             error: function(xhr, status, error){
//                 // Handle error if the cart clearing fails
//                 console.error(error);
//                 alert('Failed to clear cart. Please try again.');
//             }
//         });
//     });
// });


